import React from 'react';
import moment from 'moment';
import api from 'api';
import { Spinner } from 'hyperdb-utils';
import RentalRulesetEditor from '../../../daily-rental/rental-ruleset/components/RentalRulesetEditor';

class RentalRulesetTab extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {};
  }
  componentDidMount() {
    const propertyId = this.props.property.id;
    if (!this.props.id) {
      const objectData = {
        id: 0,
        propertyId,
        default_price: { base_price: 0, base_extra: 0 },
        default_conditions: { min_stay: 1 },
      };
      this.props.api.rentalRuleset.submitCreateForm(objectData)
        .then(() => {
          if (this.props.savedObject) {
            const id = this.props.savedObject.id;
            this.props.api.rentalRuleset.initEditForm(id);
            this.props.api.property.updateEditedObject({
              attributeName: 'daily_rental_ruleset',
              value: { $type: 'reference', external: true, value: ['daily_rental_rulesets', id] },
            });
          }
        });
    } else {
      this.props.api.rentalRuleset.initEditForm(this.props.id);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.submitSuccessful) {
      this.props.api.rentalRuleset.setData({ submitSuccessful: false, formChanged: false });
      this.props.api.rentalRuleset.updateEditedObject({ data: nextProps.savedObject, noSetDirty: true });
    }
  }
  render() {
    if (!this.props.objectData) return <Spinner show={ this.props.show } />;
    return (
      <div style={ {display: this.props.show ? 'block' : 'none'} }>
        <RentalRulesetEditor
          objectData={ this.props.objectData }
          property={ this.props.property }
          onChange={ this.handleChange }
          onChangePropertyFields={ this.props.onChangePropertyFields }
          onPricesAndConditionsChanged={ this.props.onChange }
          errorBasePrice={ this.props.errorBasePrice }
        />
      </div>
    );
  }
  handleChange(attributeName, field) {
    const { name, value } = field;
    this.props.api.rentalRuleset.updateEditedObject({ attributeName, value })
      .then(() => this.props.onChange());
  }
}

export default api.connect(RentalRulesetTab, 'rentalRuleset');



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/components/RentalRulesetTab.jsx